import React from "react";
import MouseOverCard from "../../components/commalax_v2/mouse_over_card";
import Marquee from "react-fast-marquee";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";

const HomePage = () => {
  const products = [
    {
      id: 3,
      imgae:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Finnisfree_hot1.webp?alt=media&token=43698403-453b-4160-a7c0-39d2dbbb7949",
      extra: "rounded-tr-[150px] rounded-bl-[150px]",
    },

    {
      id: 2,
      imgae:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fjm_hot1.jpg?alt=media&token=e8014c2d-4360-44f6-9296-5fbb82259cd8",
      extra: "rounded-xl",
    },
    {
      id: 1,
      imgae:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
      extra: "rounded-full",
    },
    {
      id: 4,
      imgae:
        "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_BTS_Product_02Cropped_1080x1080_34250e27-fd47-4647-ac72-b8d670c5f415_772x.jpg?v=1675089047",
      extra: "rounded-tl-[30px] rounded-br-[30px]",
    },
    {
      id: 5,
      imgae:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fjm_hot2.jpg?alt=media&token=b18759de-d7d8-4153-bb2c-215490f706c98",
    },
    {
      id: 6,
      imgae:
        "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/CA_231171045-20210223_INNISFREE-006_1080_Resized_772x.jpg?v=1672758000",
    },
    {
      id: 7,
      imgae:
        "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/IF_DUV_Product_2023_02Cropped-1080x1080.jpg?v=1675089004&width=304",
    },
    {
      id: 8,
      imgae:
        "https://jmsolution.com/web/product/medium/202211/524dcd7096e2fbf3e7b0992b9dab5350.png",
    },
    {
      id: 9,
      imgae:
        "https://carenel.com/web/product/medium/cicavita_gentle_cleanser.jpg",
    },
  ];
  const carnelproducts = [
    {
      id: 3,
      image1:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Finnisfree_hot1.webp?alt=media&token=43698403-453b-4160-a7c0-39d2dbbb7949",
      extra: "rounded-tr-[150px] rounded-bl-[150px]",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
    },
    {
      id: 1,
      image1:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
      extra: "rounded-full",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Finnisfree_hot1.webp?alt=media&token=43698403-453b-4160-a7c0-39d2dbbb7949",
    },

    {
      id: 2,
      image1:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fjm_hot1.jpg?alt=media&token=e8014c2d-4360-44f6-9296-5fbb82259cd8",
      extra: "rounded-xl",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
    },
    {
      id: 4,
      image1:
        "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_BTS_Product_02Cropped_1080x1080_34250e27-fd47-4647-ac72-b8d670c5f415_772x.jpg?v=1675089047",
      extra: "rounded-tl-[30px] rounded-br-[30px]",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
    },
    {
      id: 5,
      image1:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Finnisfree_hot1.webp?alt=media&token=43698403-453b-4160-a7c0-39d2dbbb7949",
      extra: "rounded-tr-[150px] rounded-bl-[150px]",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
    },
    {
      id: 6,
      image1:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
      extra: "rounded-full",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Finnisfree_hot1.webp?alt=media&token=43698403-453b-4160-a7c0-39d2dbbb7949",
    },

    {
      id: 7,
      image1:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fjm_hot1.jpg?alt=media&token=e8014c2d-4360-44f6-9296-5fbb82259cd8",
      extra: "rounded-xl",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
    },
    {
      id: 8,
      image1:
        "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_BTS_Product_02Cropped_1080x1080_34250e27-fd47-4647-ac72-b8d670c5f415_772x.jpg?v=1675089047",
      extra: "rounded-tl-[30px] rounded-br-[30px]",
      image2:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
    },
  ];
  return (
    <div className="">
      {/* what we're loving  */}
      <div className="py-20 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 ">
        <h1 className="text-3xl text-center pb-5">What We're Loving</h1>
        <div className="marquee">
          <div className="flex track">
            {products.map((pd) => (
              <div className="w-60 mx-10">
                <img
                  src={pd?.imgae}
                  className="w-full h-auto rounded-lg shadow-lg"
                  alt=""
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CARE:NEL  */}
      <div className="bg-[#F1E8E3] py-10">
        <h1 className="text-center text-3xl mb-5">CARE:NEL</h1>
        <p className="w-96 mx-auto mb-5 text-center">
          Lorem ipsum dolor sit amet consec. Lorem, ipsum dolor sit amet
          consectetur adipisicing elit. Quam, nobis!
        </p>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          slidesPerView={6}
          navigation={{
            prevEl: ".prev",
            nextEl: ".next",
          }}
          // navigation
          // pagination={{ clickable: true }}
          // scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log("slide change")}
        >
          {carnelproducts?.map((item) => (
            <SwiperSlide key={item}>
              <MouseOverCard item={item} />
            </SwiperSlide>
          ))}
          <div className="mx-auto w-full flex justify-center gap-5 mt-20">
            <div className="prev bg-yellow-500 p-3 rounded-full">
              <AiOutlineArrowLeft className="" />
            </div>
            <div className="next bg-yellow-500 p-3 rounded-full">
              <AiOutlineArrowRight className="next" />
            </div>
          </div>
        </Swiper>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="bg-gray-700"
      >
        <path
          fill="#F1E8E3"
          fill-opacity="1"
          d="M0,160L40,160C80,160,160,160,240,176C320,192,400,224,480,197.3C560,171,640,85,720,80C800,75,880,149,960,192C1040,235,1120,245,1200,234.7C1280,224,1360,192,1400,176L1440,160L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"
        ></path>
      </svg>

      {/* 2nd Products  */}
      <div className="bg-gray-700 text-white py-10">
        <h1 className="text-center text-3xl mb-5">CARE:NEL</h1>
        <p className="w-96 mx-auto mb-5 text-center">
          Lorem ipsum dolor sit amet consec. Lorem, ipsum dolor sit amet
          consectetur adipisicing elit. Quam, nobis!
        </p>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          slidesPerView={6}
          navigation={{
            prevEl: ".prev",
            nextEl: ".next",
          }}
          // navigation
          // pagination={{ clickable: true }}
          // scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log("slide change")}
        >
          {carnelproducts?.map((item) => (
            <SwiperSlide key={item}>
              <MouseOverCard item={item} />
            </SwiperSlide>
          ))}
          <div className="mx-auto w-full flex justify-center gap-5 mt-20">
            <div className="prev bg-yellow-500 p-3 rounded-full">
              <AiOutlineArrowLeft className="" />
            </div>
            <div className="next bg-yellow-500 p-3 rounded-full">
              <AiOutlineArrowRight className="next" />
            </div>
          </div>
        </Swiper>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="bg-white"
      >
        <path
          fill="#374151"
          fill-opacity="1"
          d="M0,160L40,160C80,160,160,160,240,176C320,192,400,224,480,197.3C560,171,640,85,720,80C800,75,880,149,960,192C1040,235,1120,245,1200,234.7C1280,224,1360,192,1400,176L1440,160L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"
        ></path>
      </svg>

      {/* 3rd Products  */}
      <div className="py-20 relative">
        <h1 className="text-center text-3xl mb-5">CARE:NEL</h1>
        <p className="w-96 mx-auto mb-5 text-center">
          Lorem ipsum dolor sit amet consec. Lorem, ipsum dolor sit amet
          consectetur adipisicing elit. Quam, nobis!
        </p>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          slidesPerView={6}
          navigation={{
            prevEl: ".prev",
            nextEl: ".next",
          }}
          // navigation
          // pagination={{ clickable: true }}
          // scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log("slide change")}
        >
          {carnelproducts?.map((item) => (
            <SwiperSlide key={item}>
              <MouseOverCard item={item} />
            </SwiperSlide>
          ))}
          <div className="mx-auto w-full flex justify-center gap-5 mt-20">
            <div className="prev bg-yellow-500 p-3 rounded-full">
              <AiOutlineArrowLeft className="" />
            </div>
            <div className="next bg-yellow-500 p-3 rounded-full">
              <AiOutlineArrowRight className="next" />
            </div>
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default HomePage;

// <div>
// <div class="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 py-20">
//   <h1 className="text-4xl text-center">What We're Loving</h1>
//   <div className="flex py-10 justify-center gap-5 overflow-hidden">
//     {products?.map((item) => (
//       <div key={item.id} className="">
//         <img src={item?.imgae} alt="" className={`h-72 ${item?.extra}`} />
//       </div>
//     ))}
//   </div>
// </div>
// <div className="bg-yellow-100 py-20">
//   <h1 className="text-4xl text-center">CARE:NEL</h1>
//   <p className="text-center w-[700px] mx-auto">
//     CARE:NEL has studied people's skin types and their needs since 2013
//     with skin-friendly ingredients that alleviate irritated skin.
//   </p>
//   <div className="flex py-10 justify-center gap-5 overflow-hidden">
//     {carnelproducts?.map((item) => (
//       <MouseOverCard item={item} key={item.id} />
//     ))}
//   </div>
// </div>
// <svg
//   xmlns="http://www.w3.org/2000/svg"
//   viewBox="0 0 1440 320"
//   className="bg-gray-700"
// >
//   <path
//     fill="#fef9c3"
//     fillOpacity="1"
//     d="M0,96L60,117.3C120,139,240,181,360,170.7C480,160,600,96,720,96C840,96,960,160,1080,170.7C1200,181,1320,139,1380,117.3L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
//   ></path>
// </svg>

// <div className="bg-gray-700 py-20">
//   <h1 className="text-4xl text-center text-white">CARE:NEL</h1>
//   <p className="text-center w-[700px] mx-auto text-white">
//     CARE:NEL has studied people's skin types and their needs since 2013
//     with skin-friendly ingredients that alleviate irritated skin.
//   </p>
//   <div className="flex py-10 justify-center gap-5 overflow-hidden">
//     {carnelproducts?.map((item) => (
//       <MouseOverCard item={item} key={item.id} />
//     ))}
//   </div>
// </div>
// <svg
//   xmlns="http://www.w3.org/2000/svg"
//   viewBox="0 0 1440 320"
//   className="absolute"
// >
//   <path
//     fill="#374151"
//     fillOpacity="1"
//     d="M0,96L60,117.3C120,139,240,181,360,170.7C480,160,600,96,720,96C840,96,960,160,1080,170.7C1200,181,1320,139,1380,117.3L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
//   ></path>
// </svg>

// <div className="py-20">
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 1440 320"
//     className=""
//   >
//     <path
//       fill="#fff"
//       fillOpacity="1"
//       d="M0,96L60,117.3C120,139,240,181,360,170.7C480,160,600,96,720,96C840,96,960,160,1080,170.7C1200,181,1320,139,1380,117.3L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
//     ></path>
//   </svg>
//   <h1 className="text-4xl text-center">CARE:NEL</h1>
//   <p className="text-center w-[700px] mx-auto">
//     CARE:NEL has studied people's skin types and their needs since 2013
//     with skin-friendly ingredients that alleviate irritated skin.
//   </p>
//   <div className="flex py-10 justify-center gap-5 overflow-hidden">
//     {carnelproducts?.map((item) => (
//       <MouseOverCard item={item} key={item.id} />
//     ))}
//   </div>
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 1440 320"
//     className="bg-white"
//   >
//     <path
//       fill="#fff"
//       fillOpacity="1"
//       d="M0,96L60,117.3C120,139,240,181,360,170.7C480,160,600,96,720,96C840,96,960,160,1080,170.7C1200,181,1320,139,1380,117.3L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
//     ></path>
//   </svg>
// </div>
// </div>
